<template>
	<div>
		<div class="d-flex mt-6">
			<itens-adesao-btn-mais-acoes
				class="mr-2"
				v-if="botaoAcoesEmMassaPodeAparecer"
				:block="$vuetify.breakpoint.smAndDown"
				:permissoes-em-massa="permissoesBotoesAcoesEmMassa"
				@estornar="abrirModalEstorno(itensSelecionadosListagem, true)"
			>
			</itens-adesao-btn-mais-acoes>
			<botao-primario
				v-az-auth="permissoes.ataAdesaoGerarRelatorioPrevio"
				v-if="podeExibirBotaoRelatorioAdesao"
				id="visualizarAdesao"
				outlined
				icone="description"
				cor-icone="primary"
				nome-botao="VISUALIZAR ADESÃO"
				@click="baixarRelatorioPrevio"
			></botao-primario>
		</div>
		<itens-adesao-listagem
			:total-paginas="listagem.totalPaginas"
			:total-itens="listagem.totalItens"
			:itens="listagem.datasource"
			:has-authority="hasAutority"
			:permissao-visualizar-saldo="listagem.isVisualizarSaldo"
			@paginar="paginarListagem"
			@resetar-page="resetarPaginaListagem"
			@salvar-item="eventSalvar"
			@limpar-campo="salvar"
			@abrir-modal-estorno="abrirModalEstorno"
		></itens-adesao-listagem>
		<modal-estorno-item-adesao
			:exibir="modalEstorno.exibir"
			:itens="modalEstorno.itens"
			:is-estornar="modalEstorno.isEstornar"
			@fechar-modal="fecharModalEstorno"
			@carregar-listagem="carregarItensAdesao"
		></modal-estorno-item-adesao>
	</div>
</template>
<script>
import ItensAdesaoListagem from '@/views/pages/adesao/aderente/itens/listagem/ItensAdesaoListagem.vue'
import { actionTypes, mutationTypes } from '@/core/constants'
import { mapState } from 'vuex'
import SalvarItemDisponivelQuantidadeAdesaoInput from '@/core/apiclient/adesao/models/SalvarItemDisponivelQuantidadeAdesaoInput'
import { LoadingScreen } from '@/core/utils'
import BotaoPrimario from '@/views/components/BotaoPrimario'
import permissoes from '@/core/constants/permissoes'
import adesaoAta from '@/views/mixins/adesaoAta'
import validacaoAta from '@/views/mixins/validacaoAta'
import ModalEstornoItemAdesao from '@/views/pages/adesao/aderente/itens/estorno/ModalEstornoItemAdesao.vue'
import ItensAdesaoBtnMaisAcoes from '@/views/pages/adesao/aderente/itens/botoes/ItensAdesaoBtnMaisAcoes.vue'

export default {
	name: 'adesao-itens-view',
	components: { ModalEstornoItemAdesao, ItensAdesaoBtnMaisAcoes, BotaoPrimario, ItensAdesaoListagem },
	mixins: [adesaoAta, validacaoAta],
	inject: ['idAdesao'],
	async beforeRouteLeave(to, from, next) {
		await this.salvarAoSair()
			.then(() => next())
			.catch(() => next(false))
	},
	emits: ['tem-itens-preenchidos'],
	data() {
		return {
			listagem: {
				totalItens: 0,
				totalPaginas: 0,
				datasource: [],
				estaSalvando: false,
				isVisualizarSaldo: false,
			},
			salvarTimeout: [],
			timeoutAutosave: 800,
			loading: new LoadingScreen(this.$store),
			modalEstorno: {
				exibir: false,
				itens: [],
				isEstornar: true,
			},
			permissoesBotoesAcoesEmMassa: this.getTodasPermissoesAcoesEmMassa(),
		}
	},
	computed: {
		...mapState({
			adesao: (state) => state.adesao.informacoesAdesao || {},
			filtro: (state) => state.adesao.filtro,
			isPossuiItensEmElaboracao: (state) => state.adesao.isPossuiItensEmElaboracao,
			isPossuiItensEmRascunho: (state) => state.adesao.isPossuiItensEmRascunho,
			itensSelecionadosListagem: (state) => state.adesao.itensAdesao.itensSelecionados,
			paginacao: (state) => state.adesao.paginacao,
			atualizaListagem: (state) => state.adesao.atualizaListagem,
		}),
		hasAutority() {
			return (
				this.temPermissao &&
				!this.isAtaCancelada &&
				!this.isAtaProrrogada &&
				!this.isConcluida &&
				!this.estaRecusada &&
				this.isPermissaoAutorizada(permissoes.ataAdesaoItemInserir) &&
				this.verificarPermissao(permissoes.ataAdesaoItemInserir)
			)
		},
		isAtaProrrogada() {
			return this.ehHistoricoProrrogacao(this.adesao?.ataRegistroPreco.situacao)
		},
		botaoAcoesEmMassaPodeAparecer() {
			return this.validarPermissoesBotoesAcoesEmMassa()
		},
		isAtaCancelada() {
			return this.estaCancelada(this.adesao.ataRegistroPreco?.situacao)
		},
	},
	watch: {
		async atualizaListagem() {
			await this.carregarItensAdesao()
		},
	},
	async mounted() {
		await this.carregarItensAdesao()
		await this.atualizaInstanciaDoProcesso()
	},
	beforeDestroy() {
		this.resetarPaginaListagem()
		this.$store.commit(mutationTypes.ADESAO.RESET_ITENS_SELECIONADOS)
		this.$store.commit(mutationTypes.ADESAO.RESETAR_PAGINA_LISTAGEM)
		this.$store.commit(mutationTypes.LOKI.RESET_AUTO_SAVE)
	},
	methods: {
		podeExibirBotaoRelatorioAdesao() {
			return (
				this.isPermissaoAutorizada(permissoes.ataAdesaoGerarRelatorioPrevio) &&
				this.verificarPermissao(permissoes.ataAdesaoGerarRelatorioPrevio)
			)
		},
		async salvarAoSair() {
			await this.temSalvamentoPendente()
			return true
		},
		async paginarListagem(paginacao) {
			this.setPaginacaoItensAtaListagem(paginacao)
			await this.carregarItensAdesao()
			this.mostrarNotificacaoSucesso('Itens da ata carregados com sucesso!')
		},
		async carregarItensAdesao() {
			let {
				itens,
				totalElements,
				totalPages,
				isPossuiItensNaAdesaoEmElaboracao,
				isPossuiItensNaAdesaoEmRascunho,
				isVisualizarSaldo,
			} = await this.$store.dispatch(actionTypes.ADESAO.BUSCAR_ITENS, {
				paginacao: this.paginacao,
				idAdesao: this.idAdesao,
			})
			this.listagem.datasource = this.getItensListagem(itens)
			this.listagem.totalItens = totalElements
			this.listagem.totalPaginas = totalPages
			this.listagem.isVisualizarSaldo = isVisualizarSaldo
			this.$store.commit(mutationTypes.ADESAO.SET_POSSUI_ITENS, {
				elaboracao: isPossuiItensNaAdesaoEmElaboracao,
				rascunho: isPossuiItensNaAdesaoEmRascunho,
			})
		},
		getItensListagem(itens) {
			return itens.map((item) => {
				item._quantidadeSolicitada = item.quantidadeSolicitada
				return item
			})
		},
		setPaginacaoItensAtaListagem(paginacao) {
			this.$store.commit(mutationTypes.ADESAO.SET_PAGINACAO_LISTAGEM, paginacao)
		},
		resetarPaginaListagem() {
			this.$store.commit(mutationTypes.ADESAO.RESETAR_PAGINA_LISTAGEM)
		},
		async eventSalvar(item) {
			clearTimeout(this.salvarTimeout[item.idItemAta])
			this.removerTimeout(item.idItemAta)
			const evento = async function (item) {
				await this.salvarItem(item)
			}.bind(this)
			this.salvarTimeout[item.idItemAta] = setTimeout(evento, this.timeoutAutosave, item)
		},
		removerTimeout(index) {
			this.salvarTimeout.splice(index, 1)
		},
		async salvarItem(item) {
			if (this.podeSalvarItem(item)) {
				try {
					if (item._quantidadeSolicitada > 0) {
						await this.salvar(item)
					} else {
						item._quantidadeSolicitada = item.quantidadeSolicitada
					}
					this.removerTimeout(item.idItemAta)
				} catch (e) {
					item._quantidadeSolicitada = item.quantidadeSolicitada
					this.removerTimeout(item.idItemAta)
				}
			}
		},
		async salvar(item) {
			const { isPossuiItensNaAdesaoEmElaboracao, isPossuiItensNaAdesaoEmRascunho } =
				await this.executarSemLoading(() =>
					this.$store.dispatch(
						actionTypes.ADESAO.SALVAR_ITEM_DISPONIVEL_QUANTIDADE,
						new SalvarItemDisponivelQuantidadeAdesaoInput(
							this.idAdesao,
							item.idItemAta,
							item._quantidadeSolicitada,
						),
					),
				)

			item.quantidadeSolicitada = item._quantidadeSolicitada
			item.quantitativoDesatualizado = false

			this.$store.commit(mutationTypes.ADESAO.SET_POSSUI_ITENS, {
				elaboracao: isPossuiItensNaAdesaoEmElaboracao,
				rascunho: isPossuiItensNaAdesaoEmRascunho,
			})
		},
		podeSalvarItem(item) {
			return (
				(item._quantidadeSolicitada &&
					item._quantidadeSolicitada > 0 &&
					item.quantidadeSolicitada !== item._quantidadeSolicitada) ||
				(item.quantidadeSolicitada > 0 && (!item._quantidadeSolicitada || item._quantidadeSolicitada === 0))
			)
		},
		async temSalvamentoPendente() {
			this.loading.start()
			let contTimeout = 0
			while (contTimeout <= 5 && this.temTimeout()) {
				await this.sleep(500)
				contTimeout++
			}

			this.loading.stop()
		},
		sleep(ms) {
			return new Promise((resolve) => setTimeout(resolve, ms))
		},
		temTimeout() {
			return (
				this.salvarTimeout.filter((item) => {
					return item > 0
				}).length > 0
			)
		},
		async baixarRelatorioPrevio() {
			await this.$store.dispatch(actionTypes.ADESAO.BAIXAR_RELATORIO_PREVIO, this.idAdesao)
		},
		getTodasPermissoesAcoesEmMassa() {
			return {
				estornar: () => this.podeEstornar(),
			}
		},
		podeEstornar() {
			return (
				this.isPermissaoAutorizada(permissoes.ataAdesaoItemEstornar) &&
				this.verificarPermissao(permissoes.ataAdesaoItemEstornar) &&
				this.temPermissao &&
				!this.isAtaCancelada &&
				this.isConcluida
			)
		},
		validarPermissoesBotoesAcoesEmMassa() {
			const permissoes = this.permissoesBotoesAcoesEmMassa
			return permissoes.estornar()
		},
		abrirModalEstorno(itens, isEstornar) {
			this.modalEstorno.itens = itens
			this.modalEstorno.isEstornar = isEstornar
			this.modalEstorno.exibir = true
		},
		fecharModalEstorno() {
			this.modalEstorno.exibir = false
			this.modalEstorno.itens = []
		},
	},
}
</script>
